import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';

export const getAllEmployeeList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.EMP_MNGT_GET_ALL_EMPLOYEE_LIST,
    data,
  });
};
export const getEmployeeFullDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.EMP_MNGT_GET_EMPLOYEE_DETAILS,
    params,
  });
};

export const updateEmployeeStatus = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.PUT,
    url: URL.EMP_MNGT_UPDATE_EMPLOYEE_STATUS,
    data,
  });
};

export const updateRole = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.PUT,
    url: URL.EMP_MNGT_UPDATE_ROLE,
    data,
  });
};
export const updatePersonalDetails = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.PUT,
    url: URL.EMP_MNGT_UPDATE_PERSONAL_DETAILS,
    data,
  });
};
